import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sf-resultContainer" }
const _hoisted_2 = { class: "sf-creditSurcharge" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "sf-resultTitle" }, [
  /*#__PURE__*/_createTextVNode(" Kredyt #naStart"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("projekt programu rządowego ")
], -1)
const _hoisted_4 = { class: "sf-resultTableContainer" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "sf-resultSubtitle" }, "Pierwsze 10 lat:", -1)
const _hoisted_6 = { class: "sf-resultTable" }
const _hoisted_7 = { class: "sf-resultTableRow sf-rowDark" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableDCell sf-cellLeft sf-surchargeValue smallCol" }, " Rata ", -1)
const _hoisted_9 = { class: "sf-resultTableDCell sf-surchargeValue" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\">Rodzaj rat</div><div class=\"sf-resultTableCell\">malejące</div></div><div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft fluidTableFont\"> Rodzaj oprocentowania </div><div class=\"sf-resultTableCell\">stałe</div></div>", 2)
const _hoisted_12 = { class: "sf-resultTableRow" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft" }, "Oprocentowanie", -1)
const _hoisted_14 = { class: "sf-resultTableCell" }
const _hoisted_15 = { class: "sf-resultSubtitle" }
const _hoisted_16 = { class: "sf-resultTable" }
const _hoisted_17 = { class: "sf-resultTableRow sf-rowDark" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableDCell sf-cellLeft sf-surchargeValue smallCol" }, " Rata ", -1)
const _hoisted_19 = { class: "sf-resultTableDCell sf-surchargeValue" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\">Rodzaj rat</div><div class=\"sf-resultTableCell\">równe</div></div><div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\"> Rodzaj oprocentowania </div><div class=\"sf-resultTableCell\">zmienne</div></div>", 2)
const _hoisted_22 = { class: "sf-resultTableRow" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft" }, "Oprocentowanie", -1)
const _hoisted_24 = { class: "sf-resultTableCell" }
const _hoisted_25 = { class: "sf-resultTableRow" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft sf-surchargeValue" }, " Koszt odsetkowy ", -1)
const _hoisted_27 = { class: "sf-resultTableCell sf-surchargeValue" }
const _hoisted_28 = { class: "sf-creditStandard" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", { class: "sf-resultTitle" }, [
  /*#__PURE__*/_createTextVNode(" Kredyt hipoteczny z okresowo"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("stałym oprocentowaniem ")
], -1)
const _hoisted_30 = { class: "sf-resultTableContainer" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "sf-resultSubtitle" }, "Pierwsze 10 lat:", -1)
const _hoisted_32 = { class: "sf-resultTable" }
const _hoisted_33 = { class: "sf-resultTableRow sf-rowDark" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableDCell sf-cellLeft sf-standardValue smallCol" }, " Rata ", -1)
const _hoisted_35 = { class: "sf-resultTableDCell sf-standardValue" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\">Rodzaj rat</div><div class=\"sf-resultTableCell\">równe</div></div><div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\"> Rodzaj oprocentowania </div><div class=\"sf-resultTableCell\">stałe</div></div>", 2)
const _hoisted_38 = { class: "sf-resultTableRow" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft" }, "Oprocentowanie", -1)
const _hoisted_40 = { class: "sf-resultTableCell" }
const _hoisted_41 = { class: "sf-resultSubtitle" }
const _hoisted_42 = { class: "sf-resultTable" }
const _hoisted_43 = { class: "sf-resultTableRow sf-rowDark" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableDCell sf-cellLeft sf-standardValue smallCol" }, " Rata ", -1)
const _hoisted_45 = { class: "sf-resultTableDCell sf-standardValue" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\">Rodzaj rat</div><div class=\"sf-resultTableCell\">równe</div></div><div class=\"sf-resultTableRow\"><div class=\"sf-resultTableCell sf-cellLeft\"> Rodzaj oprocentowania </div><div class=\"sf-resultTableCell\">zmienne</div></div>", 2)
const _hoisted_48 = { class: "sf-resultTableRow" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft" }, "Oprocentowanie", -1)
const _hoisted_50 = { class: "sf-resultTableCell" }
const _hoisted_51 = { class: "sf-resultTableRow" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "sf-resultTableCell sf-cellLeft sf-standardValue" }, " Koszt odsetkowy ", -1)
const _hoisted_53 = { class: "sf-resultTableCell sf-standardValue" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.surcharge.installmentFirstTen, "PLN")), 1)
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.apiData.api.surcharge.installmentFirstTenPercent) + " % ", 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_15, "Kolejne " + _toDisplayString(_ctx.creditRestPeriod) + " lat:", 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.surcharge.installmentNextTen, "PLN")), 1)
          ]),
          _hoisted_20,
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.apiData.api.surcharge.installmentNextTenPercent) + " % ", 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.surcharge.installmentTotal, "PLN")), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.regular.installmentFirstTen, "PLN")), 1)
          ]),
          _hoisted_36,
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.apiData.api.regular.installmentFirstTenPercent) + " % ", 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_41, "Kolejne " + _toDisplayString(_ctx.creditRestPeriod) + " lat:", 1),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.regular.installmentNextTen, "PLN")), 1)
          ]),
          _hoisted_46,
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.apiData.api.regular.installmentNextTenPercent) + " % ", 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.showAsCurrency(_ctx.apiData.api.regular.installmentTotal, "PLN")), 1)
          ])
        ])
      ])
    ])
  ]))
}